import type { PlaniraLogData } from "../../shared/types";
import BaseWriteApi from "./BaseWriteApi";

export default class PlaniraLogApi extends BaseWriteApi<PlaniraLogData> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}planira_log`;
  }
}
